enum PageAction {
  OTHER,
  LIST,
  CREATE,
  EDIT,
}

export default PageAction;
